const banks = [{
	"bank": "American Express",
	"order": 1,
	"cards": [
			{
				"name": "Platinum Edge Credit Card",
				"points": [
				{
					"bankPoints": "4,500-6,799",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "6,800-15,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "16,000-39,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "40,000-78,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "79,000-159,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "160,000-314,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">630,000",
					"velocityPoints": ">720,000"
				}
				],
				"minimumPoints": "2,000",
				"totalBonus": "15",
				"bonusFinePrint": ""
			},
			{
				"name": "Platinum Rewards Credit Card",
				"points": [
				{
					"bankPoints": "4,500-6,799",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "6,800-15,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "16,000-39,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "40,000-78,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "79,000-159,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "160,000-314,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">630,000",
					"velocityPoints": ">720,000"
				}
				],
				"minimumPoints": "2,000",
				"totalBonus": "15",
				"bonusFinePrint": ""
			},
			{
				"name": "Platinum Reserve Credit Card",
				"points": [
				{
					"bankPoints": "4,500-6,799",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "6,800-15,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "16,000-39,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "40,000-78,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "79,000-159,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "160,000-314,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">630,000",
					"velocityPoints": ">720,000"
				}
				],
				"minimumPoints": "2,000",
				"totalBonus": "15",
				"bonusFinePrint": ""
			},
			{
				"name": "Corporate Card",
				"points": [
				{
					"bankPoints": "4,500-6,799",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "6,800-15,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "16,000-39,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "40,000-78,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "79,000-159,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "160,000-314,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">630,000",
					"velocityPoints": ">720,000"
				}
				],
				"minimumPoints": "2,000",
				"totalBonus": "15",
				"bonusFinePrint": ""
			},
			{
				"name": "Business Accelerator Credit Card",
				"points": [
				{
					"bankPoints": "4,500-6,799",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "6,800-15,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "16,000-39,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "40,000-78,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "79,000-159,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "160,000-314,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">630,000",
					"velocityPoints": ">720,000"
				}
				],
				"minimumPoints": "2,000",
				"totalBonus": "15",
				"bonusFinePrint": ""
			},
			{
				"name": "Gold Card",
				"points": [
				{
					"bankPoints": "4,500-6,799",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "6,800-15,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "16,000-39,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "40,000-78,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "79,000-159,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "160,000-314,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">630,000",
					"velocityPoints": ">720,000"
				}
				],
				"minimumPoints": "2,000",
				"totalBonus": "15",
				"bonusFinePrint": ""
			},
			{
				"name": "Centurion Card",
				"points": [
				{
					"bankPoints": "4,000-6,499",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "6,500-14,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "15,000-35,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "36,000-71,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "72,000-144,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "145,000-289,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "290,000-579,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">580,000",
					"velocityPoints": ">720,000"
				}
				],
				"minimumPoints": "2,000",
				"totalBonus": "25",
				"bonusFinePrint": "That's an extra 10% on top of the 15% Velocity Bonus"
			},
			{
				"name": "Rewards Advantage Card",
				"points": [
				{
					"bankPoints": "4,000-6,499",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "6,500-14,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "15,000-35,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "36,000-71,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "72,000-144,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "145,000-289,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "290,000-579,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">580,000",
					"velocityPoints": ">720,000"
				}
				],
				"minimumPoints": "2,000",
				"totalBonus": "25",
				"bonusFinePrint": "That's an extra 10% on top of the 15% Velocity Bonus"
			},
			{
				"name": "Platinum Card",
				"points": [
				{
					"bankPoints": "4,000-6,499",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "6,500-14,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "15,000-35,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "36,000-71,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "72,000-144,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "145,000-289,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "290,000-579,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">580,000",
					"velocityPoints": ">720,000"
				}
				],
				"minimumPoints": "2,000",
				"totalBonus": "25",
				"bonusFinePrint": "That's an extra 10% on top of the 15% Velocity Bonus"
			},
			{
				"name": "David Jones American Express Card",
				"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
				],
				"minimumPoints": "2,000",
				"totalBonus": "15",
				"bonusFinePrint": ""
			},
			{
				"name": "David Jones Platinum American Express Card",
				"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
				],
				"minimumPoints": "2,000",
				"totalBonus": "15",
				"bonusFinePrint": ""
			},
			{
				"name": "Business Card",
				"points": [
				{
					"bankPoints": "6600-10,499",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "10,500-23,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "24,000-58,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "59,000-117,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "118,000-234,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "235,000-469,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "470,000-939,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">940,000",
					"velocityPoints": ">720,000"
				}
				],
				"minimumPoints": "2,000",
				"totalBonus": "15",
				"bonusFinePrint": ""
			},
			{
				"name": "Gold Business Card",
				"points": [
				{
					"bankPoints": "6600-10,499",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "10,500-23,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "24,000-58,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "59,000-117,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "118,000-234,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "235,000-469,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "470,000-939,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">940,000",
					"velocityPoints": ">720,000"
				}
				],
				"minimumPoints": "2,000",
				"totalBonus": "15",
				"bonusFinePrint": ""
			},
			{
				"name": "Platinum Business Card",
				"points": [
				{
					"bankPoints": "6600-10,499",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "10,500-23,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "24,000-58,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "59,000-117,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "118,000-234,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "235,000-469,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "470,000-939,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">940,000",
					"velocityPoints": ">720,000"
				}
				],
				"minimumPoints": "2,000",
				"totalBonus": "15",
				"bonusFinePrint": ""
			},
			{
				"name": "Essential&trade; Credit Card",
				"points": [
				{
					"bankPoints": "5,800-8,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "9,000-20,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "21,000-52,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "53,000-104,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "105,000-209,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "210,000-419,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "420,000-834,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">835,000",
					"velocityPoints": ">720,000"
				}
				],
				"minimumPoints": "2,000",
				"totalBonus": "15",
				"bonusFinePrint": ""
			},
			{
				"name": "Gold Credit Card",
				"points": [
				{
					"bankPoints": "5,800-8,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "9,000-20,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "21,000-52,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "53,000-104,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "105,000-209,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "210,000-419,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "420,000-834,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">835,000",
					"velocityPoints": ">720,000"
				}
				],
				"minimumPoints": "2,000",
				"totalBonus": "15",
				"bonusFinePrint": ""
			},
			{
				"name": "Explorer&trade; Credit Card",
				"points": [
				{
					"bankPoints": "5,800-8,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "9,000-20,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "21,000-52,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "53,000-104,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "105,000-209,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "210,000-419,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "420,000-834,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">835,000",
					"velocityPoints": ">720,000"
				}
				],
				"minimumPoints": "2,000",
				"totalBonus": "15",
				"bonusFinePrint": ""
			}
		],
	"cities": [
		"Adelaide",
		"Brisbane",
		"Cairns",
		"Canberra",
		"Darwin",
		"Hobart",
		"Melbourne",
		"Perth",
		"Sydney"
	]

}, {
	"bank": "ANZ",
	"order": 2,
	"cards": [
		{
			"name": "Rewards Credit Card",
			"points": [
				{
					"bankPoints": "6,700-10,499",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "10,500-23,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "24,000-59,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "60,000-119,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "120,000-239,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "240,000-479,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "480,000-959,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">960,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "2",
			"totalBonus": "50",
			"bonusFinePrint": "That's an extra 35% on top of the 15% Velocity Bonus"
		},
		{
			"name": "Rewards Platinum Credit Card",
			"points": [
				{
					"bankPoints": "6,700-10,499",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "10,500-23,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "24,000-59,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "60,000-119,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "120,000-239,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "240,000-479,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "480,000-959,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">960,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "2",
			"totalBonus": "50",
			"bonusFinePrint": "That's an extra 35% on top of the 15% Velocity Bonus"
		},
		{
			"name": "Rewards Black Credit Card",
			"points": [
				{
					"bankPoints": "6,700-10,499",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "10,500-23,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "24,000-59,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "60,000-119,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "120,000-239,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "240,000-479,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "480,000-959,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">960,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "2",
			"totalBonus": "50",
			"bonusFinePrint": "That's an extra 35% on top of the 15% Velocity Bonus"
		},
		{
			"name": "Rewards Travel Adventures Card",
			"points": [
				{
					"bankPoints": "6,700-10,499",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "10,500-23,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "24,000-59,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "60,000-119,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "120,000-239,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "240,000-479,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "480,000-959,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">960,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "2",
			"totalBonus": "50",
			"bonusFinePrint": "That's an extra 35% on top of the 15% Velocity Bonus"
		}
	],
	"cities": [
		"Adelaide",
		"Brisbane",
		"Cairns",
		"Canberra",
		"Darwin",
		"Hobart",
		"Melbourne",
		"Perth",
		"Sydney"
	]
}, {
	"bank": "ANZ Business",
	"order": 3,
	"cards": [
		{
			"name": "Business Rewards",
			"points": [
				{
					"bankPoints": "7,500-11,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "12,000-26,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "27,000-67,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "68,000-134,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "135,000-269,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "270,000-539,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "540,000-1,079,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,080,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "2,500",
			"totalBonus": "50",
			"bonusFinePrint": "That's an extra 35% on top of the 15% Velocity Bonus"
		},
		{
			"name": "Business Rewards Options",
			"points": [
				{
					"bankPoints": "7,500-11,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "12,000-26,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "27,000-67,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "68,000-134,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "135,000-269,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "270,000-539,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "540,000-1,079,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,080,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "2,500",
			"totalBonus": "50",
			"bonusFinePrint": "That's an extra 35% on top of the 15% Velocity Bonus"
		},
		{
			"name": "Business Black Credit Card",
			"points": [
				{
					"bankPoints": "7,500-11,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "12,000-26,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "27,000-67,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "68,000-134,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "135,000-269,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "270,000-539,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "540,000-1,079,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,080,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "2,500",
			"totalBonus": "50",
			"bonusFinePrint": "That's an extra 35% on top of the 15% Velocity Bonus"
		},
	],
	"cities": [
		"Adelaide",
		"Brisbane",
		"Cairns",
		"Canberra",
		"Darwin",
		"Hobart",
		"Melbourne",
		"Perth",
		"Sydney"
	]
}, {
	"bank": "Bank of Queensland",
	"order": 4,
	"cards": [
		{
			"name": "Platinum Visa Credit Card",
			"points": [
				{
					"bankPoints": "30,000-46,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "47,000-117,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "118,000-234,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "235,000-469,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "470,000-939,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "940,000-1,899,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,900,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "30,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}

	],
	"cities": [
		"Adelaide",
		"Brisbane",
		"Cairns",
		"Canberra",
		"Darwin",
		"Hobart",
		"Melbourne",
		"Perth",
		"Sydney"
	]
}, {
	"bank": "Card Services",
	"order": 5,
	"cards": [
		{
			"name": "Rewards Platinum MasterCard",
			"points": [
				{
					"bankPoints": "25,000-39,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "40,000-97,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "98,000-199,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "200,000-394,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "395,000-784,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "785,000-1,599,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,600,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "25,000",
			"totalBonus": "15",
			"bonusFinePrint": ""

		},
		{
			"name": "Rewards Gold MasterCard",
			"points": [
				{
					"bankPoints": "25,000-39,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "40,000-97,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "98,000-199,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "200,000-394,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "395,000-784,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "785,000-1,599,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,600,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "25,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}


	],
	"cities": [
		"Adelaide",
		"Brisbane",
		"Cairns",
		"Canberra",
		"Darwin",
		"Hobart",
		"Melbourne",
		"Perth",
		"Sydney"
	]
}, {
	"bank": "Citibank",
	"order": 6,
	"cards": [
		{
			"name": "Citi Prestige Card",
			"points": [
				{
					"bankPoints": "20,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "20,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Citi Rewards Signature Card",
			"points": [
				{
					"bankPoints": "20,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "20,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Citi Business Gold Card",
			"points": [
				{
					"bankPoints": "20,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "20,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Citi Rewards Platinum Card",
			"points": [
				{
					"bankPoints": "25,000-39,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "40,000-97,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "98,000-199,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "200,000-394,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "395,000-784,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "785,000-1,599,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,600,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "25,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Citi Gold Visa Card",
			"points": [
				{
					"bankPoints": "25,000-39,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "40,000-97,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "98,000-199,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "200,000-394,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "395,000-784,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "785,000-1,599,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,600,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "25,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}
	],
	"cities": [
		"Adelaide",
		"Brisbane",
		"Cairns",
		"Canberra",
		"Darwin",
		"Hobart",
		"Melbourne",
		"Perth",
		"Sydney"
	]
}, {
	"bank": "Commonwealth Bank",
	"order": 7,
	"cards": [
		{
			"name": "Platinum Awards Credit Card",
			"points": [
			    {
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,600",
			"totalBonus": "15",
			"bonusFinePrint": ""

		},
		{
			"name": "Diamond Awards Credit Card",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,600",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Business Platinum Awards Credit Card",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,600",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Awards Credit Card",
			"points": [
				{
					"bankPoints": "11,000-16,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "17,000-39,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "40,000-97,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "98,000-199,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "200,000-394,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "395,000-784,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "785,000-1,599,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,600,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,600",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Awards Gold Credit Card",
			"points": [
				{
					"bankPoints": "11,000-16,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "17,000-39,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "40,000-97,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "98,000-199,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "200,000-394,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "395,000-784,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "785,000-1,599,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,600,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,600",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Business Awards Credit Card",
			"points": [
				{
					"bankPoints": "11,000-16,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "17,000-39,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "40,000-97,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "98,000-199,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "200,000-394,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "395,000-784,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "785,000-1,599,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,600,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,600",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Business Awards Gold Credit Card",
			"points": [
				{
					"bankPoints": "11,000-16,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "17,000-39,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "40,000-97,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "98,000-199,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "200,000-394,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "395,000-784,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "785,000-1,599,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,600,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,600",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}
	],
	"cities": [
		"Adelaide",
		"Brisbane",
		"Cairns",
		"Canberra",
		"Darwin",
		"Hobart",
		"Melbourne",
		"Perth",
		"Sydney"
	]
}, {
	"bank": "Diners Club",
	"order": 8,
	"cards": [
		{
			"name": "Personal Card",
			"points": [
				{
					"bankPoints": "7500-10,499",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "10,500-23,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "24,000-58,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "59,000-117,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "118,000-234,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "235,000-469,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "470,000-939,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">940,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "7,500",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Business Card",
			"points": [
				{
					"bankPoints": "7500-10,499",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "10,500-23,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "24,000-58,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "59,000-117,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "118,000-234,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "235,000-469,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "470,000-939,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">940,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "7,500",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}
	],
	"cities": [
		"Adelaide",
		"Brisbane",
		"Cairns",
		"Canberra",
		"Darwin",
		"Hobart",
		"Melbourne",
		"Perth",
		"Sydney"
	]
}, {
	"bank": "HSBC",
	"order": 9,
	"cards": [
		{
			"name": "Premier World MasterCard",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "5,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Platinum Credit Card",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "5,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}
	],
	"cities": [
		"Adelaide",
		"Brisbane",
		"Cairns",
		"Canberra",
		"Darwin",
		"Hobart",
		"Melbourne",
		"Perth",
		"Sydney"
	]
}, {
	"bank": "NAB",
	"order": 10,
	"cards": [
		{
			"name": "Rewards Classic Card",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Rewards Platinum Card",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Rewards Business Platinum Card",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}
	],
	"cities": [
		"Adelaide",
		"Brisbane",
		"Cairns",
		"Canberra",
		"Darwin",
		"Hobart",
		"Melbourne",
		"Perth",
		"Sydney"
	]
}, {
	"bank": "Bank of Melbourne",
	"order": 11,
	"cards": [
		{
			"name": "Amplify Credit Card (Auto Redeem only)",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Amplify Platinum Credit Card (Auto Redeem only)",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Amplify Signature Credit Card Card (Auto Redeem only",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Amplify Business Credit Card (Auto Redeem only)",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}
	],
	"cities": [
		"Adelaide",
		"Brisbane",
		"Cairns",
		"Canberra",
		"Darwin",
		"Hobart",
		"Melbourne",
		"Perth",
		"Sydney"
	]
}, {
	"bank": "BankSA",
	"order": 12,
	"cards": [
		{
			"name": "Amplify Credit Card (Auto Redeem only)",
			"points":  [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Amplify Platinum Credit Card (Auto Redeem only)",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Amplify Signature Credit Card Card (Auto Redeem only",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Amplify Business Credit Card (Auto Redeem only)",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
	],
	"cities": [
		"Adelaide",
		"Brisbane",
		"Cairns",
		"Canberra",
		"Darwin",
		"Hobart",
		"Melbourne",
		"Perth",
		"Sydney"
	]
}, {
	"bank": "Suncorp Bank",
	"order": 13,
	"cards": [
		{
			"name": "Clear Options Platinum Credit Card",
			"points": [
				{
					"bankPoints": "25,000-39,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "40,000-97,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "98,000-199,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "200,000-394,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "395,000-784,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "785,000-1,599,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,600,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "25,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Clear Options Business Credit Card",
			"points": [
				{
					"bankPoints": "25,000-39,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "40,000-97,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "98,000-199,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "200,000-394,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "395,000-784,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "785,000-1,599,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,600,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "25,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}


	],
	"cities": [
		"Adelaide",
		"Brisbane",
		"Cairns",
		"Canberra",
		"Darwin",
		"Hobart",
		"Melbourne",
		"Perth",
		"Sydney"
	]
}, {
	"bank": "St George Bank",
	"order": 14,
	"cards": [
		{
			"name": "Amplify Credit Card (Auto Redeem only)",
			"points":  [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Amplify Platinum Credit Card (Auto Redeem only)",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Amplify Signature Credit Card Card (Auto Redeem only",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Amplify Business Credit Card (Auto Redeem only)",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
	],
	"cities": [
		"Adelaide",
		"Brisbane",
		"Cairns",
		"Canberra",
		"Darwin",
		"Hobart",
		"Melbourne",
		"Perth",
		"Sydney"
	]
}, {
	"bank": "Westpac",
	"order": 15,
	"cards": [
		{
			"name": "Altitude Credit Card (Auto Redeem only)",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Altitude Platinum Credit Card (Auto Redeem only)",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Altitude Platinum Plus Credit Card (Auto Redeem only)",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Altitude Black Credit Card (Auto Redeem only)",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Altitude Business Credit Card (Auto Redeem only)",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Altitude Business Gold Credit Card (Auto Redeem only)",
			"points": [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		},
		{
			"name": "Altitude Business Platinum Credit Card (Auto Redeem only)",
			"points":  [
				{
					"bankPoints": "8,700-13,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "14,000-31,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "32,000-78,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "79,000-156,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "157,000-314,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "315,000-629,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "630,000-1,254,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,255,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}
	],
	"cities": [
		"Adelaide",
		"Brisbane",
		"Cairns",
		"Canberra",
		"Darwin",
		"Hobart",
		"Melbourne",
		"Perth",
		"Sydney"
	]
}, {
	"bank": "flybuys (inc. Coles Mastercard)",
	"order": 16,
	"cards": [
		{
			"name": "flybuys card",
			"points": [
			{
					"bankPoints": "10,000-15,999",
					"velocityPoints": "5,000-7,799"
				},
				{
					"bankPoints": "16,000-35,999",
					"velocityPoints": "7,800-17,999"
				},
				{
					"bankPoints": "36,000-89,999",
					"velocityPoints": "18,000-44,999"
				},
				{
					"bankPoints": "90,000-179,999",
					"velocityPoints": "45,000-89,999"
				},
				{
					"bankPoints": "180,000-359,999",
					"velocityPoints": "90,000-179,999"
				},
				{
					"bankPoints": "360,000-719,999",
					"velocityPoints": "180,000-359,999"
				},
				{
					"bankPoints": "720,000-1,439,999",
					"velocityPoints": "360,000-719,999"
				},
				{
					"bankPoints": ">1,440,000",
					"velocityPoints": ">720,000"
				}
			],
			"minimumPoints": "2,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}

	],
	"cities": [
		"Adelaide",
		"Brisbane",
		"Cairns",
		"Canberra",
		"Darwin",
		"Hobart",
		"Melbourne",
		"Perth",
		"Sydney"
	]

	}
]
export default banks



// WEBPACK FOOTER //
// ./components/calculate-my-bonus/cards.js